var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50004 0.833496C4.43754 0.833496 0.333374 4.93766 0.333374 10.0002C0.333374 15.0627 4.43754 19.1668 9.50004 19.1668C14.5625 19.1668 18.6667 15.0627 18.6667 10.0002C18.6667 4.93766 14.5625 0.833496 9.50004 0.833496ZM13.4734 8.45016C13.5465 8.36653 13.6022 8.26911 13.6372 8.16364C13.6722 8.05816 13.6857 7.94676 13.6769 7.83598C13.6682 7.72521 13.6374 7.6173 13.5864 7.5186C13.5353 7.41991 13.465 7.33242 13.3797 7.26128C13.2943 7.19014 13.1956 7.1368 13.0893 7.10438C12.983 7.07196 12.8713 7.06113 12.7608 7.07252C12.6502 7.08391 12.5431 7.11728 12.4457 7.17069C12.3482 7.2241 12.2624 7.29645 12.1934 7.3835L8.61004 11.6827L6.75587 9.82766C6.5987 9.67586 6.3882 9.59187 6.16971 9.59377C5.95121 9.59567 5.7422 9.68331 5.58769 9.83781C5.43318 9.99232 5.34554 10.2013 5.34365 10.4198C5.34175 10.6383 5.42574 10.8488 5.57754 11.006L8.07754 13.506C8.15942 13.5878 8.25745 13.6517 8.36539 13.6935C8.47332 13.7354 8.58879 13.7543 8.70443 13.749C8.82007 13.7438 8.93335 13.7145 9.03705 13.663C9.14075 13.6116 9.23258 13.5391 9.30671 13.4502L13.4734 8.45016Z",
    fill: "#66B966"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckicon);
export default __webpack_public_path__ + "static/media/checkicon.579aaf6948cff9be6f9d9efd5d2c0d94.svg";
export { ForwardRef as ReactComponent };